/*
  'prep'
  'layup'
  'infusion'
  'inspection'
  'webAndClose'
  'post-inspection'
 */

const stageMap = {
  prep : {
    name : 'Shell Prep',
  },
  'mold prep' : {
    name : 'Shell Prep',
    className : 'prep',
  },
  layup : {
    name : 'Layup',
  },
  infusion : {
    name : 'Infusion',
  },
  inspection : {
    name : 'Inspection',
  },
  webAndClose : {
    name : 'Web Assembly & Closing',
  },
  'post-inspection' : {
    name : 'Web Assembly & Closing',
    className : 'webAndClose',
  },
  default : {
    name : 'Inactive',
    className : 'inactive'
  }
}

export default function getStage( stage ) {
  return stageMap[stage] || stageMap.default
}
